import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { Trophy, Clock, Check, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          return {
            hours: 0,
            minutes: 0,
            seconds: 0
          };
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section className="relative py-12 px-4 overflow-hidden" data-id="element-215">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 50% 30%, rgba(245,198,160,0.12) 0%, rgba(245,198,160,0.04) 50%, transparent 80%)'
    }} data-id="element-216" />

      <div className="relative max-w-5xl mx-auto" data-id="element-217">
        {/* Stack value */}
        <FadeIn className="text-center mb-8" data-id="element-218">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-mint mb-3" data-id="element-219">
            La oferta redonda
          </h2>
          <p className="text-white/60 text-lg" data-id="element-220">Mirá todo lo que te llevás:</p>
        </FadeIn>

        <FadeIn delay={0.1} className="max-w-2xl mx-auto mb-8" data-id="element-221">
          <div className="bg-surface border border-mint/10 rounded-2xl overflow-hidden" data-id="element-222">
            {[{
            label: 'MegaPack de Lectoescritura (6 Tomos)',
            price: '$64.990'
          }, {
            label: 'PLAN PRO – Intervención y Gestión Profesional',
            price: '$29.990'
          }, {
            label: 'Kit de seguimiento, informes y comunicación',
            price: '$18.990'
          }, {
            label: '6 Bonos Estratégicos',
            price: '$12.990'
          }].map((item, i) => <div key={i} className="flex items-center justify-between px-5 py-4 border-b border-mint/10 last:border-0" data-id="element-223">
                <span className="text-white/80 text-sm md:text-base" data-id="element-224">
                  {item.label}
                </span>
                <span className="text-white/50 text-sm md:text-base font-medium" data-id="element-225">
                  {item.price}
                </span>
              </div>)}
            <div className="flex items-center justify-between px-5 py-4 bg-white/5" data-id="element-226">
              <span className="text-white/60 font-bold uppercase text-sm" data-id="element-227">
                Total por separado:
              </span>
              <span className="text-white/40 line-through font-bold text-lg" data-id="element-228">
                $126.960
              </span>
            </div>
          </div>
        </FadeIn>

        {/* Urgency Counter */}
        <FadeIn className="text-center mb-6" data-id="element-229">
          <div className="inline-flex items-center gap-3 bg-red-500/10 border border-red-500/30 rounded-full px-6 py-3 mb-4" data-id="element-230">
            <Clock size={18} className="text-red-400" data-id="element-231" />
            <span className="text-red-400 font-bold text-sm uppercase tracking-wide" data-id="element-232">
              Precio de lanzamiento termina en
            </span>
            <div className="flex items-center gap-1 font-mono" data-id="element-233">
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-234">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-red-400 font-bold" data-id="element-235">:</span>
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-236">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-red-400 font-bold" data-id="element-237">:</span>
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-238">
                {pad(timeLeft.seconds)}
              </span>
            </div>
          </div>
          <p className="text-white/60 text-lg font-medium" data-id="element-239">
            Después sube y no vuelve al mismo precio.
          </p>
        </FadeIn>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-8 mt-8" data-id="element-240">
          {/* Card 1: Base */}
          <FadeIn delay={0.1} data-id="element-241">
            <div className="relative bg-surface border border-mint/20 rounded-3xl p-8 flex flex-col h-full" data-id="element-242">
              <div className="mb-4" data-id="element-243">
                <h3 className="text-white mb-2 text-[20px] font-[900] font-['Open_Sans',_sans-serif] uppercase" data-id="element-244">
                  📚 MegaPack Lectoescritura
                </h3>
                <p className="text-white/50 text-sm font-medium" data-id="element-245">
                  6 tomos + 6 bonos
                </p>
              </div>

              <div className="mb-6" data-id="element-246">
                <p className="text-white/40 line-through text-lg mb-1" data-id="element-247">
                  $34.990
                </p>
                <p className="text-5xl font-[900] text-white font-['Open_Sans',_sans-serif]" data-id="element-248">
                  $19.990
                  <span className="text-base text-white/40 font-normal ml-2" data-id="element-249">
                    ARS
                  </span>
                </p>
              </div>

              <motion.a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBvyqtR3EsBTUjzFejQxik/es-ar?_r=AQABaLwowYczX5mq7ia3puARWTgZMfh_Ye-Moflp1E3hhIg&cart_link_id=nUXSoC3U&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full mt-auto bg-white/10 hover:bg-white/15 text-white font-bold py-4 rounded-xl transition-colors border border-white/10 flex items-center justify-center gap-2" data-id="element-250">
                QUIERO LA VERSIÓN BASE
              </motion.a>
            </div>
          </FadeIn>

          {/* Card 2: PRO (Highlighted) */}
          <FadeIn delay={0.2} data-id="element-251">
            <motion.div className="relative bg-surface border-2 border-mint rounded-3xl p-8 flex flex-col h-full shadow-2xl shadow-mint/10 md:-translate-y-4" animate={{
            boxShadow: ['0 0 20px rgba(245,198,160,0.08)', '0 0 40px rgba(245,198,160,0.15)', '0 0 20px rgba(245,198,160,0.08)']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-252">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-mint text-black font-bold px-5 py-1.5 rounded-full text-sm flex items-center gap-1.5 shadow-lg shadow-mint/30" data-id="element-253">
                <Star size={14} fill="currentColor" data-id="element-254" /> MÁS ELEGIDO
              </div>

              <div className="mb-4 mt-2" data-id="element-255">
                <h3 className="text-mint mb-2 text-[20px] font-[900] font-['Open_Sans',_sans-serif] uppercase" data-id="element-256">
                  🚀 MegaPack + PLAN PRO
                </h3>
                <p className="text-white/50 text-sm font-medium" data-id="element-257">
                  6 tomos + 6 bonos + 5 recursos PRO (Rutas, Informes, Agenda,
                  Mapa de Decisión y Devoluciones)
                </p>
              </div>

              <div className="inline-flex self-start items-center gap-1.5 bg-mint/15 border border-mint/30 text-mint text-xs font-bold px-3 py-1.5 rounded-full mb-4" data-id="element-258">
                <Trophy size={14} data-id="element-259" /> AHORRÁS $98.970
              </div>

              <div className="mb-6" data-id="element-260">
                <p className="text-white/40 line-through text-lg mb-1" data-id="element-261">
                  $126.960
                </p>
                <p className="text-5xl font-[900] text-mint font-['Open_Sans',_sans-serif]" data-id="element-262">
                  🏆 $27.990
                  <span className="text-base text-white/40 font-normal ml-2" data-id="element-263">
                    ARS
                  </span>
                </p>
              </div>

              <ul className="space-y-3 mb-6 flex-1" data-id="element-264">
                <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-265">
                  <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-266" />
                  <span data-id="element-267">MegaPack completo (6 tomos + 6 bonos)</span>
                </li>
                <li className="border-t border-mint/10 pt-3 flex items-start gap-3 text-mint text-sm font-medium" data-id="element-268">
                  <span className="text-xs uppercase tracking-wider mt-0.5" data-id="element-269">
                    + PLAN PRO
                  </span>
                </li>
                <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-270">
                  <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-271" />
                  <span data-id="element-272">Rutas de Intervención PRO</span>
                </li>
                <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-273">
                  <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-274" />
                  <span data-id="element-275">Informes PRO listos para adaptar</span>
                </li>
                <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-276">
                  <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-277" />
                  <span data-id="element-278">Agenda PRO del consultorio</span>
                </li>
                <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-279">
                  <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-280" />
                  <span data-id="element-281">Mapa PRO de decisión psicopedagógica</span>
                </li>
                <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-282">
                  <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-283" />
                  <span data-id="element-284">Kit PRO de devoluciones profesionales</span>
                </li>
              </ul>

              <motion.a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBvzMx9estqPMwINrnPEgs/es-ar?_r=AQABsXkQ-ipPbCrMJMT_FV43Nlbo8215Uztaf_gOAXX9L5Q&cart_link_id=p9K0f5sJ&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-gradient-to-r from-mint to-amber-400 hover:from-mint/90 hover:to-amber-400/90 text-black font-[900] text-base py-4 px-6 rounded-xl shadow-lg shadow-mint/20 transition-all font-['Open_Sans',_sans-serif] flex items-center justify-center gap-2" data-id="element-285">
                🚀 QUIERO EL PLAN PRO
              </motion.a>
            </motion.div>
          </FadeIn>
        </div>
      </div>
    </section>;
}